export const formatDate = (dateString: string) => {
  const date = Date.parse(dateString);
  const ret = new Date(date).toLocaleString("sr-RS");
  return ret;
};
